const packageLabels = [
    {
        title: 'General Information',
        type: 'columns',
        fields: [
            { label: '[NUMERO]', description: 'number', visible: true },
            { label: '[DETALLES]', description: 'details', visible: true },
            { label: '[TIPOENVIO]', description: 'shipment_type', visible: true },
            { label: '[FECHACREACION]', description: 'creation_date', visible: true }
        ]
    },
    {
        title: 'Customer and Shipper',
        type: 'columns',
        fields: [
            { label: '[REMITENTE]', description: 'sender', visible: true },
            { label: '[DESTINATARIO]', description: 'receiver', visible: true }
        ]
    },
    {
        title: 'Agency',
        type: 'columns',
        fields: [
            { label: '[NOMBREAGENCIA]', description: 'agency_name', visible: true },
            {
                label: '[DIRECCIONAGENCIA]',
                description: 'agency_address',
                visible: true
            },
            { label: '[EMAILAGENCIA]', description: 'agency_email', visible: true },
            { label: '[TELEFONOAGENCIA]', description: 'agency_phone', visible: true }
        ]
    },
    {
        title: 'Company and Agent',
        type: 'columns',
        fields: [
            { label: '[NOMBREEMPRESA]', description: 'company_name', visible: true },
            { label: '[AGENTE]', description: 'agent_name', visible: true }
        ]
    },
    {
        title: 'Links',
        type: 'columns',
        fields: [
            { label: '[LINKCASILLERO]', description: 'link_pobox', visible: true },
            { label: '[LINKTRACKING]', description: 'link_tracking', visible: true },
            { label: '[LINKEMPRESA]', description: 'link_company', visible: true }
        ]
    }
];

export default packageLabels;
